import { SelectedFileStatus } from '@vizit/atoms';
import type { UploadQueueItemData } from './upload-queue.context';

export type UploadQueueAction =
  | { type: 'ADD_FILES'; payload: UploadQueueItemData[] }
  | { type: 'REMOVE_ITEM'; payload: { id: string } }
  | { type: 'UPDATE_PROGRESS'; payload: { id: string; progress: number } }
  | { type: 'UPDATE_STATUS'; payload: { id: string; status: SelectedFileStatus; error?: string } }
  | { type: 'SET_UPLOADING'; payload: { ids: string[] } }
  | { type: 'CLEAR_COMPLETED' };

export interface UploadQueueState {
  items: UploadQueueItemData[];
}

/**
 * Reducer for managing upload queue state
 *
 * @param state - Current state
 * @param action - Action to perform
 * @returns New state
 */
export function uploadQueueReducer(state: UploadQueueState, action: UploadQueueAction): UploadQueueState {
  switch (action.type) {
    case 'ADD_FILES':
      return {
        ...state,
        items: [...state.items, ...action.payload],
      };

    case 'REMOVE_ITEM':
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.payload.id),
      };

    case 'UPDATE_PROGRESS':
      return {
        ...state,
        items: state.items.map((item) =>
          item.id === action.payload.id ? { ...item, progress: action.payload.progress } : item,
        ),
      };

    case 'UPDATE_STATUS':
      return {
        ...state,
        items: state.items.map((item) =>
          item.id === action.payload.id
            ? { ...item, status: action.payload.status, error: action.payload.error }
            : item,
        ),
      };

    case 'SET_UPLOADING':
      return {
        ...state,
        items: state.items.map((item) =>
          action.payload.ids.includes(item.id) ? { ...item, status: SelectedFileStatus.Uploading } : item,
        ),
      };

    case 'CLEAR_COMPLETED':
      return {
        ...state,
        items: state.items.filter(
          (item) => item.status !== SelectedFileStatus.Success && item.status !== SelectedFileStatus.Error,
        ),
      };

    default:
      return state;
  }
}
